import { useContext } from "react";
import { ConfiguratorContext } from "../context";

/**
 * Hook para manejo de datos personales del usuario
 * Gestiona información como nombre, email, RUT, teléfono, etc.
 */
const usePersonalData = () => {
    const [state, setState] = useContext(ConfiguratorContext);

    // Obtiene los datos personales actuales
    const getPersonalData = () => (state.personalData ? state.personalData : null);

    // Actualiza los datos personales (merge con datos existentes)
    const setPersonalData = (newData) => {
        setState((prevState) => {
            return {
                ...prevState,
                personalData: {
                    ...prevState.personalData,
                    ...newData,
                },
            };
        });
    };

    // Tipo de cliente elegido en el formulario inicial: "persona" | "empresa".
    // `type` queda vacío si el usuario nunca toca el selector, así que se
    // infiere desde la razón social cuando falta.
    const getPersonType = () => {
        const personalData = getPersonalData();

        if (personalData?.type && personalData.type !== "") {
            return personalData.type;
        }

        if (personalData?.company_name && personalData.company_name.trim() !== "") {
            return "empresa";
        }

        return "persona";
    };

    const isCompany = () => getPersonType() === "empresa";

    return {
        getPersonalData,
        setPersonalData,
        getPersonType,
        isCompany,
    };
};

export default usePersonalData;
